import React from 'react';
import { Icon, Divider } from 'semantic-ui-react';
import { arrayOf, func, shape } from 'prop-types';
import Avatar from 'Modules/Avatar/Avatar';
import DoctorAvatar from 'Assets/images/commons/default-doctor.png';
import styles from './DoctorSelected.less';

const DoctorSelected = ({ selectedItems, onRemove }) => {
  const isEmpty = selectedItems.length === 0;
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {
          selectedItems.map(item => (
            <div className={styles.item} key={item.id}>
              <Avatar avatar={item.avatar?.originalPath || DoctorAvatar} />
              <div className={styles.itemText}>{item.name}</div>
              <Icon name="remove" link className={styles.action} onClick={() => onRemove(item)} />
            </div>
          ))
        }
        {
          isEmpty
          && (
            <div className={styles.empty}>Please choose doctors you want to invite</div>
          )
        }
      </div>
      <Divider />
    </div>
  );
};

DoctorSelected.propTypes = {
  onRemove: func.isRequired,
  selectedItems: arrayOf(shape({})).isRequired,
};

DoctorSelected.defaultProps = {
};

export default DoctorSelected;
